"use client";

import { useState } from "react";
import { IconHelp } from "@/components/ui/icons";
import { Popover, PopoverAnchor, PopoverContent } from "@/components/ui/popover";
import { Z } from "@/lib/z";

/**
 * Иконка-справка «?» с тултипом по hover (через портал-Popover — не обрезается таблицей/шапкой).
 * Ставить рядом с подписью заголовка столбца: <HeaderLabel>… <HelpDot text="формула" /></HeaderLabel>.
 */
export function HelpDot({ text, size = 12, maxWidth = 240 }: {
  text: string;
  size?: number;
  /** Потолок ширины подсказки. По умолчанию 240 — как у подсказок в таблицах.
   *  Шире имеет смысл там, где подсказка заменяет абзац описания (хаб настроек):
   *  в 240 px такой текст вытягивается в узкую колбасу на пол-экрана. */
  maxWidth?: number;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <span
          className="relative shrink-0 inline-flex align-middle"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          // preventDefault, а не только stopPropagation: когда «?» стоит внутри
          // ссылки (хаб настроек), одного stopPropagation мало — Link всё равно
          // уводит на страницу раздела, и подсказку прочитать нельзя.
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
          onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
        >
          <IconHelp size={size} className="text-[var(--textMuted)]/70 hover:text-[var(--text)] transition-colors cursor-help" />
        </span>
      </PopoverAnchor>
      <PopoverContent
        align="start"
        side="top"
        sideOffset={6}
        onOpenAutoFocus={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        // Ширина ПО СОДЕРЖИМОМУ, потолок прежний (240px): жёсткие 240 оставляли
        // у короткой подсказки половину пустой рамки, а длинные подсказки при
        // этом не должны стать шире, чем были.
        className="w-max px-2.5 py-2 text-[11px] font-normal normal-case leading-snug tracking-normal text-[var(--text)]"
        style={{ zIndex: Z.TOOLTIP, pointerEvents: "none", maxWidth }}
      >
        {text}
      </PopoverContent>
    </Popover>
  );
}
